module.exports = __webpack_public_path__ + "img/duye.d8baa1fd.png";